<template>
  <nav class="row navbar navbar-expand navbar-dark" style="padding-bottom: 0px; padding-top: 0px;">
    <router-link to="/" class="main float-left"><img src="/img/logofad.png"><img src="/img/ministerio-de-transicion-ecologica-reto-demografico [Convertido].png"></router-link>
    <div v-if="loggedUser" class="container text-right" style="margin-right: 0;">
      <button type="button" @click.prevent="logout()" class="btn btn-secondary float-right login"><font-awesome-icon icon="sign-out-alt" /> {{loggedUser.email}}</button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar component',
  components: {
  },
  computed: {
    loggedUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    }
  }
}
</script>

<style>
</style>
